import type { IProfile } from '@~types/types';

export function getRefLink(profileInfo: IProfile | null) {
  if (!profileInfo) {
    return '';
  }

  return document.location.origin.replace('//app.', '//') + '/?ref=' + profileInfo.ref_id;
}
